<header class="header">
    <div class="header-grp">
        <div class="back-icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>પ્રોફાઇલ</h3>
        </div>
    </div>
</header>
<main>
    <div class="profile-details">
        <div class="logo">
            <div *ngIf="imageUrlApi == '' ">
                <img [src]="imageUrl" (error)="errorHandler($event)" />
            </div>
            <div *ngIf="imageUrlApi != '' ">
                <img [src]="baseUrl+''+imageUrlApi" (error)="errorHandler($event)" />
            </div>
            <label for="file">
                <i class="ti ti-edit"></i>
                <input type="file" id="file" style="display: none" name="image"
                    accept="image/gif,image/jpeg,image/jpg,image/png" (change)="getImage($event)" multiple=""
                    data-original-title="upload photos">
            </label>
        </div>

        <div class="profile-form">
            <form [formGroup]="profileForm" (ngSubmit)="submit()">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="નામ " formControlName="name" />
                    <div *ngIf="submitted && f.name.errors" class="error-message">
                        <small *ngIf="f.name.errors?.required" class="text-danger">નામ જરૂરી છે.</small>
                    </div>
                </div>

                <div class="form-group">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input matInput [matDatepicker]="picker1" formControlName="dob" placeholder="જન્મ તારીખ"
                            [max]="maxDate">
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                    <div *ngIf="submitted && f.dob.errors" class="error-message">
                        <small *ngIf="f.dob.errors?.required" class="text-danger">જન્મ તારીખ જરૂરી છે.</small>
                    </div>
                </div>

                <div class="form-group">
                    <input type="text" class="form-control" placeholder="સંપર્ક નંબર " formControlName="contact_no"
                        maxlength="15" />
                    <!-- <div *ngIf="submitted && f.contact_no.errors" class="error-message">
                        <small *ngIf="f.contact_no.errors?.required" class="text-danger">સંપર્ક નંબર જરૂરી છે.</small>
                    </div>
                    <div *ngIf="f.contact_no.errors?.pattern && f.contact_no.touched" class="error-message">
                        <small *ngIf="f.contact_no.errors?.pattern" class="text-danger">માત્ર નંબર જ માન્ય છે.</small>
                    </div>
                    <div *ngIf="f.contact_no.errors?.minlength && f.contact_no.touched" class="error-message">
                        <small *ngIf="f.contact_no.errors?.minlength" class="text-danger">ઓછામાં ઓછા 7 નંબર જરૂરી
                            છે.</small>
                    </div> -->
                </div>

                <div class="form-group">
                    <input type="text" class="form-control" placeholder="વોટ્સએપ સંપર્ક નંબર "
                        formControlName="whatsapp_no" maxlength="15" />
                    <!-- <div *ngIf="submitted && f.whatsapp_no.errors" class="error-message">
                        <small *ngIf="f.whatsapp_no.errors?.required" class="text-danger">વોટ્સએપ સંપર્ક નંબર જરૂરી
                            છે.</small>
                    </div>
                    <div *ngIf="f.whatsapp_no.errors?.pattern && f.whatsapp_no.touched" class="error-message">
                        <small class="text-danger">માત્ર નંબર જ માન્ય છે.</small>
                    </div>
                    <div *ngIf="f.whatsapp_no.errors?.minlength && f.whatsapp_no.touched" class="error-message">
                        <small *ngIf="f.whatsapp_no.errors?.minlength" class="text-danger">ઓછામાં ઓછા 7 નંબર જરૂરી
                            છે.</small>
                    </div> -->
                </div>


                <div class="form-group">
                    <textarea class="form-control" rows="4" placeholder="સરનામું" formControlName="address"></textarea>
                    <!-- <div *ngIf="submitted && f.address.errors" class="error-message">
                        <small *ngIf="f.address.errors?.required" class="text-danger">સરનામું જરૂરી છે.</small>
                    </div> -->
                </div>

                <!-- <div class="form-group">
                    <div style="position: relative;">
                        <select class="form-control" formControlName="gender"  style="-webkit-appearance: none;">
                            <option [selected]="true">જાતિ</option>
                            <option value="female">સ્ત્રી</option>
                            <option value="male">પુરૂષ</option>
                        </select>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </div>
                    <div *ngIf="submitted && f.gender.errors" class="error-message">
                        <small *ngIf="f.gender.errors?.required" class="text-danger">જાતિ જરૂરી છે.</small>
                    </div>
                </div> -->

                <div class="form-group">
                    <div style="position: relative;">
                        <select class="form-control" formControlName="gender" style="-webkit-appearance: none;">
                            <option *ngFor="let option of genderOptions" [value]="option.value"
                                [disabled]="option.value === ''">
                                {{ option.label }}</option>
                        </select>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </div>
                    <!-- <div *ngIf="submitted && f.gender.errors" class="error-message">
                        <small *ngIf="f.gender.errors?.required" class="text-danger">જાતિ જરૂરી છે.</small>
                    </div> -->
                </div>

                <!-- <div class="form-group">
                    <div style="position: relative;">
                        <select class="form-control" formControlName="blood_group"
                            style="-webkit-appearance: none;">
                         
                         <option  [selected]="true">બ્લડ ગ્રુપ</option>
                            <option value="O-">O-</option>
                            <option value="O+">O+</option>
                            <option value="A+">A+</option>
                            <option value="A-">A-</option>
                            <option value="B+">B+</option>
                            <option value="B-">B-</option>
                            <option value="AB+">AB+</option>
                            <option value="AB-">AB-</option>
                            <option value="No idea">No idea</option>
                        </select>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </div>
                     <div *ngIf="submitted && f.blood_group.errors" class="error-message">
                        <small *ngIf="f.blood_group.errors?.required" class="text-danger">બ્લડ ગ્રુપ જરૂરી છે.</small>
                    </div> 
                </div> -->

                <div class="form-group">
                    <div style="position: relative;">
                        <select class="form-control" formControlName="blood_group" style="-webkit-appearance: none;">
                            <option *ngFor="let option of bloodGroupOptions" [value]="option.value"
                                [disabled]="option.value === ''">
                                {{ option.label }}</option>
                        </select>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </div>
                    <!--  <div *ngIf="submitted && f.blood_group.errors" class="error-message">
                        <small *ngIf="f.blood_group.errors?.required" class="text-danger">બ્લડ ગ્રુપ જરૂરી છે.</small>
                    </div>  -->
                </div>

                <div class="form-group">
                    <div style="position: relative;">
                        <select class="form-control" formControlName="education" style="-webkit-appearance: none;">
                            <option *ngFor="let option of educationOptions" [value]="option.value"
                                [disabled]="option.value === ''">
                                {{ option.label }}</option>
                        </select>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </div>
                    <!-- <div *ngIf="submitted && f.education.errors" class="error-message">
                        <small *ngIf="f.education.errors?.required" class="text-danger">શિક્ષણ જરૂરી છે.</small>
                    </div> -->
                </div>

                <div class="form-group" *ngIf="f.education.value == 'Other' ">
                    <input class="form-control" rows="4" placeholder="શિક્ષણ વર્ણન"
                        formControlName="education_description" />
                </div>

                <!-- <div class="form-group">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input type="text" placeholder="વર્તમાન શહેર " aria-label="text" matInput
                            formControlName="current_city_id" [matAutocomplete]="auto" (input)="cityFilterList($event)">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
                            <mat-option *ngFor="let data of dataCityListFilter" [value]="data"
                                (click)='cityFilter(data)'>
                                {{data.city_name}}
                            </mat-option>
                        </mat-autocomplete>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </mat-form-field>
                </div> -->

                <div class="form-group">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input type="text" placeholder="વર્તમાન શહેર " aria-label="text" matInput
                            formControlName="current_city_id" [matAutocomplete]="auto0"
                            (input)="citytFilterList($event)">
                        <mat-autocomplete autoActiveFirstOption #auto0="matAutocomplete" [displayWith]="displayFnCity">
                            <mat-option *ngFor="let data of dataCityListFilter" [value]="data"
                                (click)='cityFilter(data)'>
                                {{data.city_name}}
                            </mat-option>
                        </mat-autocomplete>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input type="text" placeholder="જિલ્લો " aria-label="text" matInput
                            formControlName="district_id" [matAutocomplete]="auto1"
                            (input)="districtFilterList($event)">
                        <mat-autocomplete autoActiveFirstOption #auto1="matAutocomplete"
                            [displayWith]="displayFnDistrict">
                            <mat-option *ngFor="let data of dataDistrictListFilter" [value]="data"
                                (click)='districtFilter(data)'>
                                {{data.district_name}}
                            </mat-option>
                        </mat-autocomplete>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input type="text" placeholder="તાલુકો" aria-label="text" matInput
                            formControlName="subdivision_id" [matAutocomplete]="auto2"
                            (input)="SubdivisionFilterList($event)">
                        <mat-autocomplete autoActiveFirstOption #auto2="matAutocomplete"
                            [displayWith]="displayFnSubdivision">
                            <mat-option *ngFor="let data of dataSubdivisionListFilter" [value]="data"
                                (click)='subdivisionFilter(data)'>
                                {{data.subdivision_name}}
                            </mat-option>
                        </mat-autocomplete>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input type="text" placeholder="ગામ " aria-label="text" matInput formControlName="village_id"
                            [matAutocomplete]="auto3" (input)="VillageFilterList($event)">
                        <mat-autocomplete autoActiveFirstOption #auto3="matAutocomplete"
                            [displayWith]="displayFnVillage">
                            <mat-option *ngFor="let data of dataVillageListFilter" [value]="data"
                                (click)='VillageFilter(data)'>
                                {{data.village_name}}
                            </mat-option>
                        </mat-autocomplete>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <input type="text" class="form-control" placeholder="વ્યવસાયનું નામ " formControlName="business" />
                </div>

                <div class="form-group">
                    <input type="text" class="form-control" placeholder="ઓફિસ સંપર્ક નંબર "
                        formControlName="office_contact" maxlength="15" />
                </div>

                <div class="form-group">
                    <textarea class="form-control" rows="4" placeholder="ઓફિસ સરનામું "
                        formControlName="office_address"></textarea>
                </div>



                <div class="form-group" [hidden]="action == 'addNewMainMember'  ||  action == 'editMainMember' ">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input type="text" placeholder="સંબંધ " aria-label="text" matInput formControlName="relation_id"
                            [matAutocomplete]="auto4" (input)="relationFilterList($event)">
                        <mat-autocomplete autoActiveFirstOption #auto4="matAutocomplete"
                            [displayWith]="displayFnsRelation">
                            <mat-option *ngFor="let data of getRelationFilterList" [value]="data"
                                (click)='relationFilter(data)'>
                                {{data.relation_name}}
                            </mat-option>
                        </mat-autocomplete>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </mat-form-field>
                    <!-- <div *ngIf="submitted && f.relation_id.errors" class="error-message">
                        <small *ngIf="f.relation_id.errors?.required" class="text-danger">સંબંધ જરૂરી
                            છે.</small>
                    </div> -->
                </div>

                <div class="form-group" [hidden]="action == 'addNewMainMember'  ||  action == 'editMainMember'">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input type="text" placeholder="સભ્ય " aria-label="text" matInput formControlName="member_id"
                            [matAutocomplete]="auto5" (input)="memberFilterList($event)">
                        <mat-autocomplete autoActiveFirstOption #auto5="matAutocomplete"
                            [displayWith]="displayFnsMember">
                            <mat-option *ngFor="let data of getMemberFilterList" [value]="data"
                                (click)='memberFilter(data)'>
                                {{data.name}}
                            </mat-option>
                        </mat-autocomplete>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </mat-form-field>
                    <!-- <div *ngIf="submitted && f.member_id.errors" class="error-message">
                        <small *ngIf="f.member_id.errors?.required" class="text-danger">સભ્ય જરૂરી છે.</small>
                    </div> -->
                </div>

                <!-- <div class="form-group">
                    <input type="text" class="form-control" placeholder="માતાનું નામ" formControlName="maternal_name" />
                    <div *ngIf="submitted && f.maternal_name.errors" class="error-message">
                        <small *ngIf="f.maternal_name.errors?.required" class="text-danger">માતાનું નામ જરૂરી છે.</small>
                    </div>
                </div> -->

                <!-- <div class="form-group">
                
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input type="text" placeholder="Select Maternal City" aria-label="text" matInput
                            formControlName="maternal_current_city_id" [matAutocomplete]="auto6"
                            (input)="maternalCityFilterList($event)" [matTooltip]="profileForm.value.current_city_id">
                        <mat-autocomplete autoActiveFirstOption #auto6="matAutocomplete"
                            [displayWith]="displayFnMaternalCity">
                            <mat-option *ngFor="let data of maternal_dataCityListFilter" [value]="data"
                                (click)='maternalCityFilter(data)'>
                                {{data.city_name}}

                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                    </mat-form-field>
                </div> -->

                <!-- <div class="form-group">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input type="text" placeholder="Select Maternal District" aria-label="text" matInput
                            formControlName="maternal_district_id" [matAutocomplete]="auto7"
                            (input)="maternalDistrictFilterList($event)" [matTooltip]="profileForm.value.district_id">
                        <mat-autocomplete autoActiveFirstOption #auto7="matAutocomplete"
                            [displayWith]="displayFnDistrict">
                            <mat-option *ngFor="let data of maternalDataDistrictListFilter" [value]="data"
                                (click)='maternalDistrictFilter(data)'>
                                {{data.district_name}}

                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
                    </mat-form-field>
                </div> -->

                <!-- <div class="form-group">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input type="text" placeholder=" Select Maternal Sub-division" aria-label="text" matInput
                            formControlName="maternal_subdivision_id" [matAutocomplete]="auto8"
                            (input)="maternalSubdivisionFilterList($event)"
                            [matTooltip]="profileForm.value.subdivision_id">
                        <mat-autocomplete autoActiveFirstOption #auto8="matAutocomplete"
                            [displayWith]="maternalDisplayFnSubdivision">

                            <mat-option *ngFor="let data of maternalDatasubdidivisionListFilter" [value]="data"
                                (click)='maternalSubdivisionFilter(data)'>
                                {{data.subdivision_name}}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>arrow_drop_down</mat-icon>
                    </mat-form-field>
                </div> -->

                <!-- <div class="form-group">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input type="text" placeholder="માતૃ ગામો " aria-label="text" matInput
                            formControlName="maternal_village_id" [matAutocomplete]="auto9"
                            (input)="maternalVillageFilterList($event)">
                        <mat-autocomplete autoActiveFirstOption #auto9="matAutocomplete"
                            [displayWith]="maternalDisplayFnVillage">

                            <mat-option *ngFor="let data of maternalDataVillageListFilter" [value]="data"
                                (click)='maternalVillageFilter(data)'>
                                {{data.maternal_village_name}}
                            </mat-option>
                        </mat-autocomplete>
                        <i class="material-icons dropdown-arrow">arrow_drop_down</i>
                    </mat-form-field>
                    <div *ngIf="submitted && f.maternal_village_id.errors" class="error-message">
                        <small *ngIf="f.maternal_village_id.errors?.required" class="text-danger">માતૃ ગામો જરૂરી
                            છે.</small>
                    </div>
                </div> -->

                <!-- <div class="form-group" [hidden]="action == 'addNewMainMember'  ||  action == 'Add'">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <input matInput [matDatepicker]="picker" placeholder="મૃત્યુ તારીખ" formControlName="death_date"
                            [max]="maxDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div> -->

                <!-- <div class="form-group" [hidden]="action == 'addNewMainMember' || action == 'Add'">
                    <mat-form-field class="example-full-width w-100" appearance="outline">
                        <div class="d-flex">
                        <input matInput [matDatepicker]="picker" placeholder="મૃત્યુ તારીખ" formControlName="death_date"
                            [max]="maxDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker (dateChange)="onDateSelected($event)"></mat-datepicker>
                
                        
                        <button mat-icon-button *ngIf="profileForm.get('death_date').value" (click)="resetDate()">
                            <i class="ti ti-minus"></i>
                        </button>
                        </div>
                    </mat-form-field>
                </div> -->

                <div class="form-group">
                    <button type="submit" class="btn-common">સાચવો </button>
                </div>
            </form>
        </div>
    </div>
</main>